import React, { useState } from 'react';
import { DashboardMenuItem, Menu, MenuItemLink, Layout } from 'react-admin';
//----icons start----
import PeopleIcon from '@mui/icons-material/People';
import LabelIcon from '@mui/icons-material/Label';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
//----icons end----
import AppBar from './Appbar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListSubheader from '@mui/material/ListSubheader';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import Drawer from '@mui/material/Drawer';
import Avatar from '@mui/material/Avatar';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import menusObj from '../../utils/sideMenuProperties';
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import dashboardlogo from '../../static/assets/Dashboard_active.png'
import cityLogo from '../../static/assets/City_Select_active.png'
import salesLogo from '../../static/assets/Sales_active.png'
import catalogLogo from '../../static/assets/Catalog_active.png'
import ajaxsuiteLogo from '../../static/assets/Ajax_Suite_active.png'
// import customerLogo from '../../static/assets/Customer_active.png'
// import marketinglogo from '../../static/assets/Marketing_active.png'
import globalStyles from '../../utils/globalStyles'
import AdminLogin from './AdminLogin';


import customerLogo from '../../static/assets/customerIcon.png';
import marketingLogo from '../../static/assets/marketingIcon.png';
import reportLogo from '../../static/assets/reportIcon.png';			  
import storeLogo from '../../static/assets/storeIcon.png';
import paymentLogo from '../../static/assets/paymentIcon.png';
//import cacheLogo from '../../static/assets/paymentIcon.png';
import StorageIcon from '@mui/icons-material/Storage';


import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';

const CustomMenu = (props) => (
    <Menu {...props} style={{ backgroundColor: 'orange', height: '100vh', justifyContent: 'space-between' }}>
        <DashboardMenuItem />
		{/* <Menu.Item to="/city-select" primaryText="City Select" leftIcon={<PeopleIcon />}/> */}
        <Menu.Item to="/sales" primaryText="Sales" leftIcon={<LabelIcon />}/>
        {/* <Menu.Item to="/catalog" primaryText="Catalog" leftIcon={<LabelIcon />}/> */}
        {/* <MenuItemLink to="/ajax-suite" primaryText="Ajax Suite" leftIcon={<LabelIcon />}/> */}
        <Menu.Item to="/users" primaryText="Customers" leftIcon={<LabelIcon />}/>
        <MenuItemLink to="/marketing" primaryText="Marketing" leftIcon={<LabelIcon />}/>
        {/* <MenuItemLink to="/content" primaryText="Content" leftIcon={<LabelIcon />}/> */}
        <MenuItemLink to="/plum-rocket" primaryText="Plum Rocket" leftIcon={<LabelIcon />}/>
        <MenuItemLink to='/reports' primaryText="Reports" leftIcon={<LabelIcon/>}/>
        <MenuItemLink to='/stores' primaryText="Stores" leftIcon={<LabelIcon/>}/>
		<MenuItemLink to='/payments' primaryText="Payments" leftIcon={<LabelIcon/>}/>
		<MenuItemLink to='/cache' primaryText="Cache Config" leftIcon={<LabelIcon/>}/>
		<MenuItemLink to='/winterorders' primaryText="Winter Camp Orders" leftIcon={<LabelIcon/>}/>

        {/* <MenuItemLink to='/find-partners' primaryText="Find Partners" leftIcon={<LabelIcon/>}/> */}
    </Menu>
);

function NestedList() {
	const [openCustomer, setOpenCustomer] = React.useState(false)
	const [openSales, setOpenSales] = React.useState(false)
	const [openMarketing, setOpenMarketing] = React.useState(false)
	const [openStore, setOpenStore] =  React.useState(false)
	const [openPayment, setOpenPayment] =  React.useState(false)
	const [openCache, setOpenCache] =  React.useState(false)
	const [adminLoginVisible,setAdminLoginVisible] = React.useState(false);
	const [openReport, setOpenReport] =  React.useState(false)
	const [openNewProduct, setOpenNewProduct] =  React.useState(false)
	const [openWinterOrders, setWinterOrders] = React.useState(false)
    const [showPendingOrders, setShowPendingOrders] = useState(false);
	const localStorageUser = localStorage.getItem('user');
	const user = JSON.parse(localStorageUser);
	const userid = user.id
	const channels = user.channel || [];
	const adminRoleId = user.admin_role_id;
	const userIds =[143,151,127];

	const handleClick = () => {
		setOpenCustomer(!openCustomer)
		setAdminLoginVisible(true)
	}

	const handleSalesClick = () => {
		setOpenSales(!openSales)
		setAdminLoginVisible(true)
	}

	const drawerClose = () => {
		console.log('drawer close clicked!')
		setOpenCustomer(false);
		setOpenSales(false);
		setOpenMarketing(false);
		setOpenStore(false);
		setOpenPayment(false);
		setOpenReport(false);
		setWinterOrders(false);
		setOpenCache(false);
	}

	const handleMarketingClick = ()=>{
		setOpenMarketing(!openMarketing)
	}

	const handlestoreClick = ()=>{
		setOpenStore(!openStore)
	}
	const handlePaymentClick = ()=>{
		setOpenPayment(!openPayment)
	}

	const handleCacheClick = ()=>{
		setOpenCache(!openCache)
	}
	const handleReportClick =() =>{
		setOpenReport(!openReport)
	}

	const handleWinterOrdersClick =() =>{
		setWinterOrders(!openWinterOrders)
	}

	function getDrawer(type = '') {
		switch (type) {
			case 'customer':
					return (
						<React.Fragment>
							<Typography 
							align='left' 
							sx={{ 
								backgroundColor: globalStyles.colors.backgroundSecondary, 
								fontSize: globalStyles.common.headingSize,
								padding: '10px 35px 5px 25px', fontWeight: 500 , lineHeight:'2'
						  }}
						>
							
								Customers
							</Typography>
						{/* <Menu sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, padding: '5px 10px 40vh', width: '100% !important' }}> */}
						<Menu sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, padding: '5px 10px', width: '100% !important' }} className='left-menu-link'>
						{adminLoginVisible && <AdminLogin />}
						<MenuItemLink to="/users" primaryText="All Customers" onClick={handleClick} sx={{
							fontWeight: 400,
							margin: '0px 10px',
							color: globalStyles.colors.white,
							'&:hover': {
								backgroundColor: globalStyles.colors.backgroundSecondary
							}
						}}/>
						<MenuItemLink to="/now-online" primaryText="Now Online" onClick={handleClick} sx={{ 
							fontWeight: 400,
							margin: '5px 10px',
							color: globalStyles.colors.white,
							'&:hover': {
								backgroundColor: globalStyles.colors.backgroundSecondary
							}
						}}/>
						<MenuItemLink to="/customer-groups" primaryText="Customer Groups" onClick={handleClick} sx={{
							fontWeight: 400,
							margin: '5px 10px',
							color: globalStyles.colors.white,
							'&:hover': {
								backgroundColor: globalStyles.colors.backgroundSecondary
							}
						}}/>
						{(userIds.includes(userid) || adminRoleId === 1) ? (
							<MenuItemLink to="/reviews" primaryText=" Customer Review" onClick={handleClick} sx={{
								fontWeight: 400,
								margin: '5px 10px',
								color: globalStyles.colors.white,
								'&:hover': {
									backgroundColor: globalStyles.colors.backgroundSecondary
								}
							}}/>
  						) : null
						}		
					</Menu>
						</React.Fragment>
				)
				break
				
			case 'orders':
				return (
					<React.Fragment>
						<Typography 
							align='left' 
							sx={{ 
								backgroundColor: globalStyles.colors.backgroundSecondary, 
								fontSize: globalStyles.common.headingSize,
								padding: '10px 35px 20px 25px', fontWeight: 500 , lineHeight:'2'
						  }}
						>
								Sales
						</Typography>
						<Box>
							<Grid container spacing={2} column={12} sx={{ backgroundColor: '#2b3f7a !important'}}>
								<Grid item xs={12}>
									<Typography variant='subtitle1' sx={{ textAlign: 'left', fontSize: '1rem', fontWeight: 600, paddingLeft:'35px' }}>
										Operations
									</Typography>
									{/* <Menu sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, padding: '5px 10px 40vh', width: '95% !important' }}> */}
									<Menu sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, padding: '5px 10px', width: '95% !important' }} className='left-menu-link'>
										<MenuItemLink to="/orders" primaryText="Orders" onClick={handleSalesClick} sx={{
											fontWeight: 400,
											margin: '0px 10px 5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}} />
										<MenuItemLink
		to="#"
		primaryText="Pending Orders"
		onClick={() => setShowPendingOrders(!showPendingOrders)}
		sx={{
			fontWeight: 400,
			margin: '0px 10px 5px 10px',
			color: globalStyles.colors.white,
			'&:hover': {
				backgroundColor: globalStyles.colors.backgroundSecondary
			}
		}}
	/>

	{/* Show child dropdown only after click */}
	{showPendingOrders && (
		<>
			<MenuItemLink
				to="/pending-orders/store-pickup"
				primaryText="Store Pickup"
				onClick={handleSalesClick}
				sx={{
					fontWeight: 400,
					margin: '5px 10px 5px 30px',
					color: globalStyles.colors.white,
					'&:hover': {
						backgroundColor: globalStyles.colors.backgroundSecondary
					}
				}}
			/>

			<MenuItemLink
				to="/pending-orders/ndd"
				primaryText="NDD"
				onClick={handleSalesClick}
				sx={{
					fontWeight: 400,
					margin: '5px 10px 5px 30px',
					color: globalStyles.colors.white,
					'&:hover': {
						backgroundColor: globalStyles.colors.backgroundSecondary
					}
				}}
			/>
		</>
	)}

										{userid !== 159 && userid !== 155 && userid !== 160 && (
											<>
										<MenuItemLink to="/shipment-status" primaryText="Shipment Status" onClick={handleSalesClick} sx={{ 
											fontWeight: 400,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
										<MenuItemLink to="/invoices" primaryText="Invoices" onClick={handleSalesClick} sx={{
											fontWeight: 400,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
										<MenuItemLink to="/shipments" primaryText="Shipments" onClick={handleSalesClick} sx={{
											fontWeight: 400,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
										
										{/* <MenuItemLink to="/creditMemos" primaryText="Credit Memos" onClick={handleSalesClick} sx={{
											fontWeight: 600,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
										<MenuItemLink to="/customer-groups" primaryText="Billing Agreements" sx={{
											fontWeight: 600,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
										<MenuItemLink to="/customer-groups" primaryText="Transactions" sx={{
											fontWeight: 600,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
										<MenuItemLink to="/customer-groups" primaryText="Abandoned Carts" sx={{
											fontWeight: 600,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
										<MenuItemLink to="/customer-groups" primaryText="Braintree Virtual Terminal" sx={{
											fontWeight: 600,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/> */}
										<MenuItemLink to="/products" primaryText=" Product Catalog" onClick={handleSalesClick} sx={{
											fontWeight: 400,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
										<MenuItemLink to="/creditMemos" primaryText="Credit Memo" onClick={handleSalesClick} sx={{
											fontWeight: 600,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/> 
										</>
										)}
									</Menu>
										
								</Grid>
								{userid !== 159 && userid !== 155 && userid !== 160 &&(
											<>
								<Grid item xs={12}>
									<Typography variant='subtitle1' sx={{ textAlign: 'left', fontSize: '1.2rem', fontWeight: 600, paddingLeft:'35px' }}>
										RMA
									</Typography>
									{/* <Menu sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, padding: '5px 10px 40vh', width: '95% !important' }}> */}
									<Menu sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, padding: '5px 10px', width: '95% !important' }} className='left-menu-link'>
										<MenuItemLink to="/returns" primaryText="Manage Returns" onClick={handleSalesClick} sx={{
											fontWeight: 400,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
										<MenuItemLink to="/" primaryText="Archive" sx={{ 
											fontWeight: 400,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
									 
									</Menu>
								</Grid>
								</>
								)}
							</Grid>
						</Box>
					</React.Fragment>
				)
				break
			
			case 'marketing':
				return (
					<React.Fragment>
						<Typography 
							align='left' 
							sx={{ 
								backgroundColor: globalStyles.colors.backgroundSecondary, 
								fontSize: globalStyles.common.headingSize,
								padding: '10px 35px 20px 25px', fontWeight: 500 , lineHeight:'2'
						  }}
						>
								Marketing
						</Typography>
						<Box>
							<Grid container spacing={2} column={12} sx={{ backgroundColor: '#2b3f7a !important'}}>
								<Grid item xs={12}>
									{/* <Menu sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, padding: '5px 10px 40vh', width: '95% !important' }}> */}
									<Menu sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, padding: '5px 10px', width: '95% !important' }} className='left-menu-link'>
										
										<MenuItemLink to="/cart-price-rule" primaryText="Cart Price Rule" onClick={handleMarketingClick} sx={{ 
											fontWeight: 400,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
										<MenuItemLink to="/gift-cart-rule" primaryText="Gift Cart Rule" onClick={handleMarketingClick} sx={{ 
											fontWeight: 600,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
									</Menu>
								</Grid>
								
							</Grid>
						</Box>
					</React.Fragment>
				)
				break
				case 'store':
				return (
					<React.Fragment>
						<Typography 
							align='left' 
							sx={{ 
								backgroundColor: globalStyles.colors.backgroundSecondary, 
								fontSize: globalStyles.common.headingSize,
								padding: '10px 35px 20px 25px', fontWeight: 500 , lineHeight:'2' 
						  }}
						>
								Stores
						</Typography>
						<Box>
							<Grid container spacing={2} column={12} sx={{ backgroundColor: '#2b3f7a !important'}}>
								<Grid item xs={12} style={{paddingTop:'0'}}>
								 
									{/* <Menu sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, padding: '5px 10px 40vh', width: '95% !important' }}> */}
									<Menu sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, padding: '5px 10px', width: '95% !important' }} className='left-menu-link'>
										<MenuItemLink to="/configuration" primaryText="configuration"  onClick={handlestoreClick} sx={{
											fontWeight: 400,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
									 
	
									</Menu>
								</Grid>
							 
							</Grid>
						</Box>
					</React.Fragment>
				)
				
				break
				case 'payment':
				return (
					<React.Fragment>
						<Typography 
							align='left' 
							sx={{ 
								backgroundColor: globalStyles.colors.backgroundSecondary, 
								fontSize: globalStyles.common.headingSize,
								padding: '10px 35px 20px 25px', fontWeight: 500 , lineHeight:'2' 
						  }}
						>
								Payment
						</Typography>
						<Box>
							<Grid container spacing={2} column={12} sx={{ backgroundColor: '#2b3f7a !important'}}>
								<Grid item xs={12} style={{paddingTop:'0'}}>
								 
									{/* <Menu sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, padding: '5px 10px 40vh', width: '95% !important' }}> */}
									<Menu sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, padding: '5px 10px', width: '95% !important' }} className='left-menu-link'>
										<MenuItemLink to="/payment/configuration" primaryText="Payment Configuration"  onClick={handlePaymentClick} sx={{
											fontWeight: 400,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
									 
	
									</Menu>
								</Grid>
							 
							</Grid>
						</Box>
					</React.Fragment>
				)
				break
				case 'cache':
				return (
					<React.Fragment>
						<Typography 
							align='left' 
							sx={{ 
								backgroundColor: globalStyles.colors.backgroundSecondary, 
								fontSize: globalStyles.common.headingSize,
								padding: '10px 35px 20px 25px', fontWeight: 500 , lineHeight:'2' 
						  }}
						>
								Cache Control
						</Typography>
						<Box>
							<Grid container spacing={2} column={12} sx={{ backgroundColor: '#2b3f7a !important'}}>
								<Grid item xs={12} style={{paddingTop:'0'}}>
								 
									{/* <Menu sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, padding: '5px 10px 40vh', width: '95% !important' }}> */}
									<Menu sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, padding: '5px 10px', width: '95% !important' }} className='left-menu-link'>
										<MenuItemLink to="/cache" primaryText="Cache Configuration"  onClick={handleCacheClick} sx={{
											fontWeight: 400,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
									</Menu>
								</Grid>
							 
							</Grid>
						</Box>
					</React.Fragment>
				)
				break
				case 'report':
				return (
					<React.Fragment>
						<Typography 
							align='left' 
							sx={{ 
								backgroundColor: globalStyles.colors.backgroundSecondary, 
								fontSize: globalStyles.common.headingSize,
								padding: '10px 35px 20px 25px', fontWeight: 500 , lineHeight:'2'
						  }}
						>
								 Exports
						</Typography>
						<Box>
							<Grid container spacing={2} column={12} sx={{ backgroundColor: '#2b3f7a !important'}}>
								<Grid item xs={12} style={{paddingTop:'0'}}>
								 
									{/* <Menu sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, padding: '5px 10px 40vh', width: '95% !important' }}> */}
									<Menu sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, padding: '5px 10px', width: '95% !important' }} className='left-menu-link'>
										<MenuItemLink to="/orderExports" primaryText=" Order Exports"  onClick={handleReportClick} sx={{

											fontWeight: 400,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
										<MenuItemLink to="/productExports" primaryText=" Product Exports"  onClick={handleReportClick} sx={{
											fontWeight: 400,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
										<MenuItemLink to="/productMasterSheet" primaryText="Product Master Sheet"  onClick={handleReportClick} sx={{
											fontWeight: 400,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
										<MenuItemLink to="/bundleReportSheet" primaryText="Bundle Report Export "  onClick={handleReportClick} sx={{
											fontWeight: 400,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
										<MenuItemLink to="/corporateGifting" primaryText=" Corporate Gifting Report"  onClick={handleReportClick} sx={{

											fontWeight: 400,
											margin: '5px 10px',
											color: globalStyles.colors.white,
											display: "block",   
                                            width: "100%",  
											'&:hover': {
												backgroundColor: globalStyles.colors.backgroundSecondary
											}
										}}/>
										{/* <MenuItemLink to="/users" primaryText="Product Exports" onClick={handleClick} sx={{
							fontWeight: 600,
							margin: '5px 10px',
							color: globalStyles.colors.white,
							'&:hover': {
								backgroundColor: globalStyles.colors.backgroundSecondary
							}
						}}/> */}
									 
	
									</Menu>
								</Grid>
							 
							</Grid>
						</Box>
					</React.Fragment>
				)
			default:
				return (
					<div>Content under development!</div>
				)
				break
		}
	}

	const avatarDimentions = { height: '25px', width: '25px'}
	const listitemButtonStyle = {
		display: 'block',
		color: globalStyles.colors.white,
		padding: '0px 10px',
		opacity: 0.5,
		margin: '20px 0px',
		alignItems: 'center',
		textAlign: 'center',
		'&:hover': {
			backgroundColor: globalStyles.colors.backgroundSecondary,
			opacity: 1
		},
		'&:active': {
			backgroundColor: globalStyles.colors.backgroundSecondary,
			opacity: 1
		},
		'& .MuiTypography-root': {
			fontSize: '10px',
			margin: 0,
			padding: 0,
		},
		'& .MuiListItemIcon-root': {
			justifyContent: 'center'
		}
	}

	return (
		<List aria-labelledby='nested-list-subheader' sx={{ position: 'sticky' }}>
			{(userid !==154 && userid !== 155) ? (
			<ListItemButton sx={{...listitemButtonStyle}} to="/">
				<ListItemIcon>
				  <Avatar src={dashboardlogo} alt='city logo' variant='square' sx={{
						'& .MuiAvatar-img': {...avatarDimentions}
					}}/>
			  </ListItemIcon>
			  <ListItemText primary='Dashboard' style={{ fontSize: '8px' }}/>
			</ListItemButton>
			):null}
			{/* <ListItemButton sx={{...listitemButtonStyle}}>
				<ListItemIcon>
				  <Avatar src={cityLogo} alt='city logo' variant='square' sx={{
						'& .MuiAvatar-img': { height: '25px', width: '20px' }
					}}/>
			  </ListItemIcon>
			  <ListItemText primary='City Select' style={{ fontSize: '8px' }}/>
			</ListItemButton> */}
			{
				(userid !== 154 && userid !== 155)?(
					<ListItemButton onClick={handleSalesClick} sx={openSales ? {...listitemButtonStyle, opacity: 1, borderLeft: '3px solid #fff'} : {...listitemButtonStyle}}>
					<ListItemIcon>
						<Avatar src={salesLogo} alt='sales logo' variant='square' sx={{
							  '& .MuiAvatar-img': {...avatarDimentions}
						  }}/>
					</ListItemIcon>
					<ListItemText primary='Sales'/>
					  {openSales && <ArrowLeftIcon sx={{ position: 'absolute', right: '-10%', top: '25%', fontSize: '26px' }}/>}
				  </ListItemButton>
				):null
			}
			
		
			<Drawer 
				anchor={'left'}
				variant='temporary'
				docked={false}
				onBackdropClick={drawerClose}
				onEscapeKeyDown={drawerClose}
				PaperProps={{
					sx: {
						// backgroundColor: globalStyles.colors.backgroundSecondary,
						backgroundColor: globalStyles.colors.backgroundPrimary,
						position: 'absolute',
						///left: '5.5%',
						left: '80px',
						// marginTop: '3.7%',
						marginTop: '60px',
						top: '0%',
						color: globalStyles.colors.white,
						width: '250px'
					}
				}}
				children={getDrawer('orders')}
				open={openSales}
			/>
			{/* <ListItemButton sx={{...listitemButtonStyle}}>
			  <ListItemIcon>
				  <Avatar src={catalogLogo} alt='catalog logo' variant='square' sx={{
						'& .MuiAvatar-img': {...avatarDimentions}
					}}/>
			  </ListItemIcon>
			  <ListItemText primary='Catalog'/>
			</ListItemButton> */}
			{/* <ListItemButton sx={{...listitemButtonStyle}}>
			  <ListItemIcon>
					<Avatar src={ajaxsuiteLogo} alt='ajax suite logo' variant='square' sx={{
						'& .MuiAvatar-img': {...avatarDimentions}
					}}/>
			  </ListItemIcon>
			  <ListItemText primary='Ajax Suite'/>
			</ListItemButton> */}
				{
				(userid !== 154 && userid !== 155 && userid !== 159 && userid !== 160) ?(
			<ListItemButton onClick={handleClick} sx={openCustomer ? {...listitemButtonStyle, opacity: 1, borderLeft: '3px solid #fff'} : {...listitemButtonStyle}}>
				<ListItemIcon>
					<Avatar src={customerLogo} alt='customer logo' variant='square' sx={{
						'& .MuiAvatar-img': {...avatarDimentions}
					}}/>
				</ListItemIcon>
				<ListItemText primary='Customers'/>
				{openCustomer && <ArrowLeftIcon sx={{ position: 'absolute', right: '-10%', top: '25%', fontSize: '26px' }}/>}
			</ListItemButton>
				):null}
			<Drawer 
				anchor={'left'} 
				open={openCustomer} 
				children={getDrawer('customer')}
				variant='temporary'
				docked={false}
				onBackdropClick={drawerClose}
				onEscapeKeyDown={drawerClose}

				PaperProps={{
					sx: {
						// backgroundColor: globalStyles.colors.backgroundSecondary,
						backgroundColor: globalStyles.colors.backgroundPrimary,
						position: 'absolute',
						///left: '5.5%',
						left: '80px',
						// marginTop: '3.7%',
						marginTop: '60px',
						top: '0%',
						color: globalStyles.colors.white,
						width: '250px'
					}
				}}
			/>
				{
				(userid !== 154 && userid !== 155 && userid !== 159 && userid !== 160) ?(
			<ListItemButton onClick={handleMarketingClick} sx={{...listitemButtonStyle}}>
			  <ListItemIcon>
					<Avatar src={marketingLogo} alt='marketing logo' variant='square' sx={{
						'& .MuiAvatar-img': {...avatarDimentions}
					}}/>
			  </ListItemIcon>
			  <ListItemText primary='Marketing'/>
			</ListItemButton>
				):null}

				{/* Marketing  Tab window*/}
			<Drawer 
				anchor={'left'}
				variant='temporary'
				docked={false}
				onBackdropClick={drawerClose}
				onEscapeKeyDown={drawerClose}
				PaperProps={{
					sx: {
						// backgroundColor: globalStyles.colors.backgroundSecondary,
						backgroundColor: globalStyles.colors.backgroundPrimary,
						position: 'absolute',
						///left: '5.5%',
						left: '80px',
						// marginTop: '3.7%',
						marginTop: '60px',
						top: '0%',
						color: globalStyles.colors.white,
						width: '250px'
					}
				}}
				children={getDrawer('marketing')}
				open={openMarketing}
			/>
			{/* <ListItemButton sx={{...listitemButtonStyle}}>
			  <ListItemIcon>
				  <Avatar src={marketinglogo} alt='marketing logo' variant='square' sx={{
						'& .MuiAvatar-img': {...avatarDimentions}
					}}/>
			  </ListItemIcon>
			  <ListItemText primary='Content'/>
			</ListItemButton> */}
			{/* <ListItemButton  sx={{...listitemButtonStyle}}>
			  <ListItemIcon>
				  <Avatar src={marketinglogo} alt='marketing logo' variant='square' sx={{
						'& .MuiAvatar-img': {...avatarDimentions}
					}}/>
			  </ListItemIcon>
			  <ListItemText primary='Plum Rocket'/>
			</ListItemButton> */}
				{
				(userid !== 154 && userid !== 155 && userid !== 159 && userid !== 160) ?(
			<ListItemButton  onClick={handleReportClick} sx={{...listitemButtonStyle}}>
			  <ListItemIcon>
				  <Avatar 
				  src={reportLogo} 
				//   src={marketinglogo} 
				  alt='marketing logo' variant='square' sx={{
						'& .MuiAvatar-img': {...avatarDimentions}
					}}/>
			  </ListItemIcon>
			  <ListItemText primary='Reports'/>
			</ListItemButton>):null}
			<Drawer 
				anchor={'left'}
				variant='temporary'
				docked={false}
				onBackdropClick={drawerClose}
				onEscapeKeyDown={drawerClose}
				PaperProps={{
					sx: {
						// backgroundColor: globalStyles.colors.backgroundSecondary,
						backgroundColor: globalStyles.colors.backgroundPrimary,
						position: 'absolute',
						///left: '5.5%',
						left: '80px',
						// marginTop: '3.7%',
						marginTop: '60px',
						top: '0%',
						color: globalStyles.colors.white,
						width: '250px'
					}
				}}
				children={getDrawer('report')}
				open={openReport}
			/>
			{
				(userid !== 154 && userid !== 155 && userid !== 159 && userid !== 160) ?(	
			<ListItemButton onClick={handlestoreClick} sx={{...listitemButtonStyle}}>
			  <ListItemIcon>
				  {/* <Avatar src={marketinglogo} alt='marketing logo' variant='square' sx={{ */}
				  <Avatar src={storeLogo} alt='marketing logo' variant='square' sx={{
						'& .MuiAvatar-img': {...avatarDimentions}
					}}/>
			  </ListItemIcon>
			  <ListItemText primary='Stores'/>
			</ListItemButton>
			):null}
			<Drawer 
				anchor={'left'}
				variant='temporary'
				docked={false}
				onBackdropClick={drawerClose}
				onEscapeKeyDown={drawerClose}
				PaperProps={{
					sx: {
						// backgroundColor: globalStyles.colors.backgroundSecondary,
						backgroundColor: globalStyles.colors.backgroundPrimary,
						position: 'absolute',
						///left: '5.5%',
						left: '80px',
						// marginTop: '3.7%',
						marginTop: '60px',
						top: '0%',
						color: globalStyles.colors.white,
						width: '250px'
					}
				}}
				children={getDrawer('store')}
				open={openStore}
			/>
			{/* <ListItemButton sx={{...listitemButtonStyle}}>
			  <ListItemIcon>
				  <Avatar src={marketinglogo} alt='marketing logo' variant='square' sx={{
						'& .MuiAvatar-img': {...avatarDimentions}
					}}/>
			  </ListItemIcon>
			  <ListItemText primary='Find Partners'/>
			</ListItemButton> */}
		{(adminRoleId == 1 && userid !==154 && userid !== 155 && userid !== 159 && userid !== 160) ? (
  			<ListItemButton onClick={handlePaymentClick} sx={{ ...listitemButtonStyle }}>
				<ListItemIcon>
     		 		{/* <Avatar src={marketinglogo} alt='marketing logo' variant='square' sx={{ '& .MuiAvatar-img': { ...avatarDimentions } }} /> */}
					  <Avatar src={paymentLogo} alt='marketing logo' variant='square' sx={{ '& .MuiAvatar-img': { ...avatarDimentions } }} />
    			</ListItemIcon>
   				<ListItemText primary='Payment' />
  			</ListItemButton>
		) : null}
			<Drawer 
				anchor={'left'}
				variant='temporary'
				docked={false}
				onBackdropClick={drawerClose}
				onEscapeKeyDown={drawerClose}
				PaperProps={{
					sx: {
						// backgroundColor: globalStyles.colors.backgroundSecondary,
						backgroundColor: globalStyles.colors.backgroundPrimary,
						position: 'absolute',
						///left: '5.5%',
						left: '80px',
						// marginTop: '3.7%',
						marginTop: '60px',
						top: '0%',
						color: globalStyles.colors.white,
						width: '250px'
					}
				}}
				children={getDrawer('payment')}
				open={openPayment}
			/>
					{(adminRoleId == 1 && userid !==154 && userid !== 155 && userid !== 159 && userid !== 160) ? (

<ListItemButton onClick={handleCacheClick} sx={{ ...listitemButtonStyle }}>
    <ListItemIcon>
        {/* <Avatar src={cacheLogo} alt='cache logo' variant='square' sx={{
            '& .MuiAvatar-img': {...avatarDimentions}
        }}/> */}
		            <StorageIcon sx={{ fontSize: 24, color: globalStyles.colors.white }} />

    </ListItemIcon>
    <ListItemText primary='Cache' />
</ListItemButton>
) : null}
<Drawer 
    anchor='left'
    open={openCache}
    variant='temporary'
    docked={false}
    onBackdropClick={drawerClose}
    onEscapeKeyDown={drawerClose}
    PaperProps={{
        sx: {
            backgroundColor: globalStyles.colors.backgroundPrimary,
            position: 'absolute',
            left: '80px',
            marginTop: '60px',
            top: '0%',
            color: globalStyles.colors.white,
            width: '250px'
        }
    }}
>
    {getDrawer('cache')}
</Drawer>
		</List>
	)
}

function CustomLayout(props) {
    return (
        <Layout {...props} menu={NestedList} appBar={AppBar} sx={{ 
					backgroundColor: globalStyles.colors.backgroundPrimary,
					position: 'absolute',
					left: 0,
					'& .MuiDrawer-docked': {
						width: '80px'
					},
					"& .RaLayout-content": {
						paddingLeft: '0px !important',
						paddingRight: '0px !important',
						overflow:'hidden'
					},
					"& .MuiInput-root:before": {
						borderBottom: 'none !important'
					},
					"& .MuiInput-root:after": {
						borderBottom: 'none !important'
					},
					"& .RaSidebarToggleButton-root": {
						display: 'none !important'
					},
					"& .MuiTablePagination-selectLabel": {
						display: 'none'
					}
				}}/>
    )
}

export default CustomLayout